import Image from "next/image";
import Link from "next/link";

type SiteLogoProps = {
  href?: string;
  priority?: boolean;
  /** Layout vertical (footer). Default: horizontal (navbar). */
  variant?: "horizontal" | "vertical";
  /** Largura em px do imagotype. Default 250 (spec VOR-54/VOR-55). */
  width?: number;
};

// VOR-54 / VOR-55: imagotype Vorseum oficial substituindo o "logo + texto"
// anterior. Versão `-white.svg` é o original `vorseum imagotype.svg`/`...vertical.svg`
// da Beatriz com `fill` invertido pra contraste em fundo escuro (canvas), aplicado
// via `sed` em build-time (sem JS extra em runtime).
const HORIZONTAL = {
  src: "/brand/vorseum-imagotype-white.svg",
  width: 790,
  height: 128,
};

const VERTICAL = {
  src: "/brand/vorseum-imagotype-vertical-white.svg",
  width: 601,
  height: 342,
};

export function SiteLogo({
  href = "/",
  priority = false,
  variant = "horizontal",
  width = 250,
}: SiteLogoProps) {
  const asset = variant === "vertical" ? VERTICAL : HORIZONTAL;
  const aspect = asset.width / asset.height;
  const computedHeight = Math.round(width / aspect);

  const content = (
    <Image
      src={asset.src}
      alt="Vorseum"
      width={width}
      height={computedHeight}
      priority={priority}
      className="block h-auto w-auto"
      style={{ width, height: computedHeight }}
    />
  );

  if (!href) {
    return content;
  }

  return (
    <Link href={href} className="shrink-0" aria-label="Ir para o início da página">
      {content}
    </Link>
  );
}
